import type { SxProps, Theme } from "@mui/material";

/**
 * No extra outer card — only light read/unread cues on the existing notification block.
 * Colors: CSS vars from index.css only, used directly.
 */
export const getNotificationItemSx = (isRead: boolean): SxProps<Theme> => ({
  position: "relative",
  cursor: "pointer",
  width: "100%",
  transition: "opacity 0.2s ease",
  opacity: isRead ? 0.72 : 1,
  ...(isRead
    ? {}
    : {
        "& > .MuiBox-root:not(.notification-new-tag)": {
          boxShadow: "inset 3px 0 0 0 var(--primary-600) !important",
          borderColor: "var(--primary-400) !important",
        },
      }),
  "&:hover": {
    opacity: 1,
  },
});

export const notificationNewTagSx: SxProps<Theme> = {
  position: "absolute",
  top: 10,
  right: 12,
  zIndex: 1,
  px: 1,
  py: 0.35,
  borderRadius: "999px",
  fontFamily: "var(--primary-font-family)",
  fontSize: "0.625rem",
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "var(--primary-bg-dark)",
  bgcolor: "var(--primary-600)",
  pointerEvents: "none",
};

export const notificationEmptyStateSx: SxProps<Theme> = {
  textAlign: "center",
  py: { xs: 7, sm: 9 },
  px: 3,
  borderRadius: "4px",
  border: "1px solid var(--primary-300)",
  bgcolor: "var(--primary-100)",
};

export const notificationPopoverPaperSx = (isMobile: boolean): SxProps<Theme> => ({
  maxWidth: isMobile ? "auto" : "380px",
  width: isMobile ? "calc(100vw - 24px)" : 380,
  mt: 1.25,
  borderRadius: "16px",
  border: "1px solid var(--primary-300)",
  boxShadow: "var(--shadow-lg)",
  p: 0,
  overflow: "hidden",
  bgcolor: "var(--primary-100-light)",
  maxHeight: "90vh",
});

export const notificationPopoverScrollSx: SxProps<Theme> = {
  px: 1.5,
  pb: 1.5,
  maxHeight: "min(60vh, 420px)",
  overflowY: "auto",
  scrollbarWidth: "thin",
  scrollbarColor: "var(--primary-400) transparent",
  "&::-webkit-scrollbar": { width: 6 },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "var(--primary-400)",
    borderRadius: 4,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "var(--primary-600)",
  },
};
